import React from 'react';
import { componentService } from 'js/services/component.service';

export const Comppoints = React.lazy(() => import(/* webpackChunkName: "loyalty-points" */ './Comppoints'));

componentService.registerPageComponents({ 'loyalty-points': Comppoints });
